import React from 'react';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import { redirectToMaintenance } from 'Helpers/Redirect';
import { Authentication } from 'Views/Authentication';
import { pick } from 'Helpers/Affordances';
import NewLogin from './ExistingLogin';

export const LoginPicker = () => {
  const { homeResource } = useHomeContext();

  const loginRelationship = homeResource.withRelationship(fr.relationships.login.name, (rel) => rel, () => null);

  // Bail if you don't have the login relationship
  React.useEffect(() => {
    if (!loginRelationship) {
      redirectToMaintenance();
    }
  }, [loginRelationship]);

  return pick(homeResource, {
    [fr.relationships.loginVisualUpdate.name]: (<Authentication url={loginRelationship.link('related').url()} />),
    [fr.relationships.loginNoAuthSession.name]: (<Authentication url={loginRelationship.link('related').url()} />),
  }, <NewLogin />);
};
